var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.translationsLoaded)?_c('component-wrapper',{attrs:{"config":_vm.$root.siteconfig.root}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }